// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-group[data-v-376db2f2] {\n  width: 100%;\n}\n.invalidField[data-v-376db2f2] {\n  border-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
